import React from 'react'
import HigherOrderComponent from '@oldscope/hoc'
import 'semantic-ui-css/components/message.css'
import ErrorBoundary from './ErrorBoundary'

export default HigherOrderComponent((InnerComponent, Opts) => {
  return class ErrorBoundaryHOC extends React.Component {
    render() {
      return (
        <ErrorBoundary>
          <InnerComponent {...this.props} />
        </ErrorBoundary>
      )
    }
  }
})
